import React from 'react';

const LAYANAN_GIGI = [
  {
    id: 1,
    icon: '🦷',
    title: 'Behel / Kawat Gigi',
    desc: 'Pemasangan behel untuk merapikan susunan gigi dan mengoreksi gigitan',
    price: 'Rp 4.000.000 - Rp 4.500.000',
  },
  {
    id: 2,
    icon: '🦷',
    title: 'Scaling / Pembersihan Karang Gigi',
    desc: 'Membersihkan karang gigi dan plak agar gigi lebih bersih dan sehat',
    price: 'Rp 300.000 - Rp 400.000',
  },
  {
    id: 3,
    icon: '🦷',
    title: 'Tambal Gigi',
    desc: 'Penambalan gigi berlubang untuk mencegah kerusakan lebih lanjut',
    price: 'Rp 300.000 - Rp 350.000',
  },
  {
    id: 4,
    icon: '🦷',
    title: 'Cabut Gigi',
    desc: 'Pencabutan gigi yang tidak bisa diperbaiki dengan prosedur aman',
    price: 'Rp 300.000 - Rp 500.000',
  },
  {
    id: 5,
    icon: '🦷',
    title: 'Konsultasi',
    desc: 'Penanganan gusi berdarah, bengkak, atau radang gusi ringan',
    price: 'Rp 100.000',
  },
  {
    id: 6,
    icon: '🦷',
    title: 'Bleaching / Pemutihan Gigi',
    desc: 'Pemeriksaan dan perawatan gigi dasar untuk anak-anak',
    price: 'Rp 1.500.000 - Rp 2.000.000',
  },
  {
    id: 7,
    icon: '🦷',
    title: 'Buat Gigi Palsu',
    desc: 'Buat gigi palsu yang nyaman dan sesuai dengan bentuk gigi anda',
    price: 'Rp 2.000.000 - Rp 4.000.000',
  },
  {
    id: 8,
    icon: '🦷',
    title: 'Perawatan Saluran Akar',
    desc: 'Jangan biarkan infeksi gigi mengganggu hari-harimu',
    price: 'Rp 3.000.000 - Rp 3.500.000',
  },
];

export function ClinicServices() {
  const services = LAYANAN_GIGI;

  return (
    <section id="layanan" style={{ padding: '3rem 1rem' }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16 clinic-section-header layanan-section-header">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 clinic-section-title layanan-section-title">
            Layanan Kesehatan Gigi
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto clinic-section-desc layanan-section-desc">
            Layanan gigi umum yang tersedia di klinik kami — daftar online dengan mudah
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 layanan-grid">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl shadow-lg layanan-card" style={{ padding: '1.25rem' }}>
              <div className="layanan-card__icon" style={{
                width: '3.25rem', height: '3.25rem',
                background: '#0ea5e9', borderRadius: '50%',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', color: 'white',
                fontSize: '1.35rem', marginBottom: '0.65rem'
              }}>
                {service.icon}
              </div>

              <h3 style={{ fontWeight: 700, color: '#1f2937', marginBottom: '0.2rem', fontSize: '0.95rem' }}>
                {service.title}
              </h3>

              <p style={{ color: '#6b7280', fontSize: '0.8rem', lineHeight: 1.5, margin: 0 }}>
                {service.desc}
              </p>

              <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid #e2e8f0' }}>
                <p style={{
                  color: '#0ea5e9',
                  fontWeight: 700,
                  fontSize: '1rem',
                  margin: 0,
                  textAlign: 'left'
                }}>
                  {service.price}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClinicServices;